import React from 'react'
import { AlertMessage } from "../types"

interface AlertProps {
  alert: AlertMessage,
  clearAlert()
}

export default function Alert({ alert, clearAlert }: AlertProps) {
  const handlePress = (onPress) => {
    if(onPress) onPress()
    clearAlert()
  }
  return (
    <div className="round-scoring-modal">
      <div className="content">
        <h2>{alert.title}</h2>
        <div className="message">{alert.message}</div>
        {alert.buttons.map((b, i) => {
          return <div key={i} className={`action ${b.style}`} onClick={() => handlePress(b.onPress)}>{b.text}</div>
        })}
      </div>
    </div>
  )
}
